(function () {
  function init() {
    var toast = document.getElementById('pz-cart-toast');
    if (!toast || toast.__pzInit) return;
    toast.__pzInit = true;
    var msg = toast.querySelector('[data-pz-toast-msg]');
    var hideTimer = null;

    function close() {
      if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
      toast.setAttribute('aria-hidden', 'true');
    }
    // Testi localizzati passati da Liquid via data-attributes (vedi
    // snippets/pz-cart-toast.liquid). Fallback italiano se mancanti.
    var tplOne = toast.getAttribute('data-msg-one') || '1 pezzo aggiunto';
    var tplMany = toast.getAttribute('data-msg-many') || '{qty} pezzi aggiunti';

    function show(qty) {
      qty = parseInt(qty, 10) || 1;
      if (msg) msg.textContent = qty === 1 ? tplOne : tplMany.replace('{qty}', qty);
      var stickyVisible = false;
      var stickyEl = document.getElementById('pz-sticky-cart');
      if (stickyEl && stickyEl.classList.contains('pz-sticky-cart--visible')) stickyVisible = true;
      toast.classList.toggle('pz-cart-toast--above-sticky', stickyVisible);
      toast.setAttribute('aria-hidden', 'false');
      if (hideTimer) clearTimeout(hideTimer);
      hideTimer = setTimeout(close, 6000);
    }
    toast.querySelectorAll('[data-pz-toast-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    toast.addEventListener('mouseenter', function () { if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; } });
    toast.addEventListener('mouseleave', function () { if (toast.getAttribute('aria-hidden') === 'false') hideTimer = setTimeout(close, 3000); });

    window.PzCartToast = { show: show, close: close };
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
